<template>
    <div>
        <compras-diretas-abertas-titulo-secao titulo="Compras Diretas Disponíveis"/>

        <az-container>
            <az-form>
                <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                              :pagination.sync="paginacaoInterna" :loading="false" :style="cssVar"
                              no-data-text="Não há compras diretas disponíveis" hide-actions
                              class="az-table-list table-todas-compras">
                    <template slot="items" slot-scope="props">
                        <tr>
                            <td @click="$emit('acessar', props.item.id)">
                                {{ props.item.dataHoraEncerramento | az-date(humanizarFormatoData(props.item.dataHoraEncerramento)) }}<br>
                                <span v-if="props.item.dataHoraEncerramento">
                                    {{ props.item.dataHoraEncerramento | az-date(humanizarFormatoHora(props.item.dataHoraEncerramento)) }}
                                </span>
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                {{ props.item.processo }}
                                <br>
                                <span v-if="props.item.quantidadeRepeticoes">
                                    <strong> Repetição: {{props.item.quantidadeRepeticoes}} </strong>
                                </span>
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                <expansao-texto :tamanho="125" :texto="props.item.objeto"/>
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                {{ props.item.tipo | cdEnum(tiposCompraDireta)}}
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                {{ props.item.orgao }}
                            </td>
                            <td @click="$emit('acessar', props.item.id)">
                                <v-tooltip top v-if="existeReenvioDocumento(props.item)">
                                    <a @click="$emit('acessarDocumentoProposta',props.item)" slot="activator">
                                      <i class="fas fa-exclamation-triangle orange--text" aria-hidden="true"></i>
                                    </a>
                                    <span>
                                        <strong>Reenvio de Documento Solicitado.</strong>
                                        <br>
                                        <strong>Verifique o Motivo da Solicitação.</strong>
                                    </span>
                                </v-tooltip>
                                {{ props.item.situacao | azEnum(situacoesCompraDireta) }}
                            </td>
                            <td class="table-actions">
                                <botao-download v-if="props.item.uri && false" :uri="props.item.uri" class="mr-3 botao-menor"/>
                                <v-tooltip top>
                                    <a @click="$emit('acessar', props.item.id)" slot="activator">
                                        <i class="fas fa-sign-in-alt pr-2" aria-hidden="true"/>
                                        <span class="acao-mobile">Acessar</span>
                                    </a>
                                    Acessar
                                </v-tooltip>
                                <v-tooltip top v-if="props.item.sequencialCompraPublica">
                                    <a @click="$emit('acessarPncp', props.item)" slot="activator">
                                        <i class="fas fa-external-link-alt" aria-hidden="true"/>
                                        <span class="acao-mobile">Acessar no PNCP</span>
                                    </a>
                                    Acessar no PNCP
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <div class="az-pagination">
                    <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
                    <div class="az-select-pagination">
                        <span>Linhas por página:</span>
                        <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                    </div>
                </div>
            </az-form>
        </az-container>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {situacoesCompraDireta, tiposCompraDireta} from '@/core/constants'
import ComprasDiretasAbertasTituloSecao from './ComprasDiretasAbertasTituloSecao'

export default {
    name: 'TodasComprasDiretasTabela',
    props: ['itens', 'paginacao', 'paginas', 'totalItens'],
    components: {
        ComprasDiretasAbertasTituloSecao
    },
    data() {
        return {
            paginacaoInterna: this.paginacao,
            situacoesCompraDireta,
            linhasPorPagina: [10, 25, 50, 100],
            colunas: [
                {
                    value: 'dataHoraEncerramento',
                    text: 'Encerramento',
                    align: 'left',
                    width: '60px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    value: 'processo',
                    text: 'Nº Processo',
                    align: 'left',
                    width: '100px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    value: 'objeto',
                    text: 'Objeto',
                    align: 'left',
                    width: '200px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    value: 'tipo',
                    text: 'Tipo',
                    align: 'left',
                    width: '80px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    value: 'orgao',
                    text: this.$t('main.fornecedor_compras_diretas_disponiveis_orgao.text'),
                    align: 'left',
                    width: '30px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'situacao',
                    text: 'Situação',
                    align: 'left',
                    width: '50px',
                    sortable: true,
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    text: 'Ações',
                    width: '30px',
                    align: 'center',
                    class: 'primary--text'
                }
            ],
            tiposCompraDireta
        }
    },
    methods:{
        existeReenvioDocumento(compraDireta) {
            return compraDireta.exiteSolicitacaoReenvioDocumento
        }
    },
    computed: {
        ...mapState(['loki']),
        cssVar() {
            const labelOrgao = this.$t('main.fornecedor_compras_diretas_disponiveis_orgao.text')
            return {
                '--label-orgao': `"${labelOrgao}:"`
            }
        }
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="stylus">
    .az-container
        margin-top 10px
        margin-bottom 60px

    .table-todas-compras
        .acao-mobile
            display none

        td:hover
            cursor pointer !important

    @media (max-width 720px)
        .table-todas-compras
            td:nth-of-type(1):before
                content "Encerramento:"

            td:nth-of-type(2):before
                content "Nº Processo:"

            td:nth-of-type(3):before
                content "Objeto:"

            td:nth-of-type(4):before
                content "Tipo:"

            td:nth-of-type(5):before
                content var(--label-orgao)

            td:nth-of-type(6):before
                content "Situação:"

            td:nth-of-type(7):before
                display none

            .acao-mobile
                display inline-block
                margin-left 3px

    @media (max-width 500px)
        .az-container
            margin-bottom 0
</style>
